module.exports = __webpack_public_path__ + "static/img/sign-bg.3e9d323.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/sign-bg.png
// module id = TZfC
// module chunks = 216